import { useNavigate } from 'react-router-dom';
import { NotificationCenter } from '@insio/ui-toolkit';
import { navigation } from '@/navigation';
import { useNotificationActivities } from './NotificationsProvider';

/** Map the backend's semantic target type to this app's route. */
function resolveHref(targetType: string, targetId: string): string {
  return targetType === 'INVOICE'
    ? navigation.invoiceDetail(targetId)
    : navigation.documentDetail(targetId);
}

/**
 * Thin host wiring for the shared notification center: renders the activities from the shared
 * `NotificationsProvider` stream. All presentation/aggregation lives in `@insio/ui-toolkit`;
 * this app only supplies data and route resolution.
 */
export function NotificationCenterContainer() {
  const navigate = useNavigate();
  const activities = useNotificationActivities();

  return (
    <NotificationCenter
      activities={activities}
      onOpen={activity => navigate(resolveHref(activity.targetType, activity.targetId))}
    />
  );
}
